import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSuitcase: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"suitcase, luggage, case"} maskId="square-filled-radius-0-stroke-1-IconSuitcase"><path fillRule="evenodd" clipRule="evenodd" d="M8 2H16V5H21V21H18V22H17V21H7V22H6V21H3V5H8V2ZM9 5H15V3H9V5ZM9 9V17H8V9H9ZM16 9V17H15V9H16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSuitcase;
